import { render, staticRenderFns } from "./MyResources.vue?vue&type=template&id=3bc5def0&scoped=true&"
import script from "./MyResources.vue?vue&type=script&lang=js&"
export * from "./MyResources.vue?vue&type=script&lang=js&"
import style0 from "./MyResources.vue?vue&type=style&index=0&id=3bc5def0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc5def0",
  null
  
)

export default component.exports